<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper landingPageBg"
    >
      <b-row>
        <b-col cols="12">
          <div class="mobile-logo">
            <img :src="logoImg">
          </div>
        </b-col>
      </b-row>
      <b-row class="row-gap">
        <b-col cols="12">
          <div class="myInfo">
            <div class="myInfoIcon">
              <img :src="retrieveIcon">
            </div>
            <div class="myInfoContent">
              <h2>{{ titleText }}</h2>
              <template v-if="transferRequest.currentStatus == 'Pending NP'">
                <template v-if="transferRequest.transferType == 'ownership'">
                  <p><strong>{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }} has initiated the transfer of ownership for {{ transferRequest.nvsFileType }}{{ transferRequest.lotLocation ? ` (${transferRequest.lotLocation})` : '' }}</strong> to you. Kindly verify your identity to proceed with the process.</p>
                </template>
                <template v-else>
                  <p><strong>{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }} has indicated an intent to transfer file {{ transferRequest.fileNo }} for {{ transferRequest.nvsFileType }}{{ transferRequest.lotLocation ? ` (${transferRequest.lotLocation})` : '' }}</strong> to you (NRIC ending {{ transferRequest.newPurchaser ? transferRequest.newPurchaser.encryptedNric.slice(-4) : '' }}).</p>
                  <p>Please verify your identity via Singpass, and you can review details of the file before making a decision to accept this transfer.</p>
                </template>
                <div class="singpass-button-img floatCss">
                  <b-img
                    :src="singPassButton"
                    class="cursor-pointer"
                    @click="singpassForm"
                  />
                </div>
              </template>
              <template v-else-if="transferRequest.currentStatus == 'Withdrawn by OP'">
                <p><strong>{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }} previously initiated a transfer request for File {{ transferRequest.fileNo }} for Niche</strong> (A-S9A-FB-38) to you (NRIC ending 551G).</p>
                <p>However, <strong>this request is no longer valid as the transferor has withdrawn it.</strong></p>
              </template>
              <template v-else-if="transferRequest.currentStatus == 'Withdrawn by NP'">
                <p><strong>{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }} previously initiated a transfer request for File {{ transferRequest.fileNo }} for Niche</strong> (A-S9A-FB-38) to you (NRIC ending 551G).</p>
                <p>However, <strong>this request is no longer valid as you have withdrawn it.</strong></p>
              </template>
              <template v-else>
                <p>{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }} has indicated an intent to transfer file {{ transferRequest.fileNo }} for {{ transferRequest.nvsFileType }}{{ transferRequest.lotLocation ? ` (${transferRequest.lotLocation})` : '' }} to you (NRIC ending {{ transferRequest.newPurchaser ? transferRequest.newPurchaser.encryptedNric.slice(-4) : '' }}).</p>
                <p v-if="transferRequest.currentStatus == 'Awaiting Approval'">
                  <strong>This request is now awaiting for Nirvana approval.</strong>
                </p>
                <p v-else-if="transferRequest.currentStatus == 'Approved'">
                  <strong>This request has been approved by Nirvana.</strong>
                </p>
                <p v-else-if="transferRequest.currentStatus == 'Rejected by NV'">
                  <strong>This request has been rejected by Nirvana.</strong>
                </p>
              </template>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="transferRequest.currentStatus == 'Pending NP'"
        class="expire_info_row"
      >
        <b-col cols="12">
          <div class="expire-info">
            This request will expire in <strong>{{ timeRemaining }}</strong>, so be sure to complete the form as soon as possible.
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="expiredLink"
      class="mobileWrapper expirePageBg"
    >
      <b-row>
        <b-col cols="12">
          <div class="mobile-logo">
            <img :src="logoImg200">
          </div>
        </b-col>
      </b-row>
      <b-row class="row-gap">
        <b-col cols="12">
          <div class="myInfo">
            <div class="myInfoIcon">
              <img :src="linkIcon">
            </div>
            <div class="myInfoContent">
              <h2>This request has expired</h2>
              <p>Your {{ titleText }} link has expired. This request will be withdrawn as it was not accepted within the required time.</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { BRow, BCol, BImg } from 'bootstrap-vue'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    // BButton,
    AppLoader,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/file-transfer/Logo-mobile.svg'),
      // eslint-disable-next-line global-require
      retrieveIcon: require('@/assets/images/file-transfer/retrieve-icon.svg'),
      // eslint-disable-next-line global-require
      logoImg200: require('@/assets/images/file-transfer/Logo-200.svg'),
      // eslint-disable-next-line global-require
      linkIcon: require('@/assets/images/file-transfer/link-icon.svg'),
      // eslint-disable-next-line global-require
      singPassButton: require('@/assets/images/frontend/singpass.png'),
      isLoading: true,
      showMessage: false,
      expiredLink: false,
      tokenDetail: {},
      transferRequest: {},
      timeRemaining: '',
      titleText: 'Change of Purchaser',
    }
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/validate/token', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              const timezone = process.env.VUE_APP_TIME_ZONE
              const now = moment().utcOffset(timezone)
              const expiresAt = moment(response.data.token.expiresAt).utcOffset(timezone)
              const duration = moment.duration(expiresAt.diff(now))

              const hours = Math.floor(duration.asHours())
              if (hours >= 24) {
                const days = Math.floor(duration.asDays())
                const remainingHours = duration.subtract(days, 'days').hours()
                const remainingMins = duration.minutes()
                this.timeRemaining = `${days} days, ${remainingHours} hrs and ${remainingMins} mins`
              } else {
                const minutes = duration.minutes()
                this.timeRemaining = `${hours} hrs and ${minutes} mins`
              }
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.showMessage = true
            } else {
              if (response.data.transferRequest && response.data.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.expiredLink = true
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    singpassForm() {
      localStorage.setItem('fileTransferToken', this.$route.params.token)
      localStorage.setItem('purchaserNric', this.transferRequest.newPurchaser ? this.transferRequest.newPurchaser.nric : '')
      // this.$router.push({ name: 'file-transfer-singpass-verification', params: { token: this.$route.params.token } })
      const formData = new FormData()
      formData.append('purpose', 'file-transfer')

      this.$http.post('front-end/singpass/file-transfer', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          localStorage.setItem('singpassAuthorizationSession', response.data.sessionID)
          // console.log(response.data.authorizationUrl)
          window.location.href = response.data.authorizationUrl
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
